import { v4 as uuid } from 'uuid';
import {
  convertTaxYearInformationDataToTaxYearInformationResponse,
  convertTaxYearInformationResponseToTaxYearInformationData,
  createDefaultTaxYearInformationData,
  ITaxYearInformationData,
  ITaxYearInformationResponse,
} from './ITaxYearInformation';
import { isNil } from 'lodash';

export interface IJurisdictionResponse {
  id?: string;
  createdAt?: string;
  taxAuthority?: string;
  payableTo?: string;
  streetAddress?: string;
  floorSuite?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  phoneNumber?: string;
  currentTaxYear?: number;
  collection?: string;
  taxYearInformation: ITaxYearInformationResponse[];
}

export interface IJurisdictionData {
  id?: string;
  createdAt?: string;
  taxAuthority?: string;
  payableTo?: string;
  streetAddress?: string;
  floorSuite?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  phoneNumber?: string;
  currentTaxYear?: number;
  collection?: string;
  taxYearInformation: ITaxYearInformationData[];
}

export const createDefaultJurisdictionData = (): IJurisdictionData =>
  ({
    id: uuid(),
    taxYearInformation: [createDefaultTaxYearInformationData()],
  }) as IJurisdictionData;

export const convertJurisdictionResponseToJurisdictionData = (res: IJurisdictionResponse): IJurisdictionData => ({
  id: res.id,
  createdAt: res.createdAt,
  taxAuthority: res.taxAuthority,
  payableTo: res.payableTo,
  streetAddress: res.streetAddress,
  floorSuite: res.floorSuite,
  city: res.city,
  state: res.state,
  zipCode: res.zipCode,
  phoneNumber: res.phoneNumber,
  currentTaxYear: res.currentTaxYear,
  collection: res.collection,
  taxYearInformation: isNil(res.taxYearInformation)
    ? []
    : res.taxYearInformation!.map((ti) => convertTaxYearInformationResponseToTaxYearInformationData(ti)),
});

export const convertJurisdictionDataToJurisdictionResponse = (data: IJurisdictionData): IJurisdictionResponse => ({
  id: data.id,
  createdAt: data.createdAt,
  taxAuthority: data.taxAuthority,
  payableTo: data.payableTo,
  streetAddress: data.streetAddress,
  floorSuite: data.floorSuite,
  city: data.city,
  state: data.state,
  zipCode: data.zipCode,
  phoneNumber: data.phoneNumber,
  currentTaxYear: data.currentTaxYear,
  collection: data.collection,
  taxYearInformation: isNil(data.taxYearInformation)
    ? []
    : data.taxYearInformation!.map((ti) => convertTaxYearInformationDataToTaxYearInformationResponse(ti)),
});
